import { getDateDiffInDays } from '@/common/utils/date'
import { TotalAvailableData, TotalAvailableMappedData } from '@/common/types/totalAvailable.type'

export class TotalAvailableTransformer {
  static withDaysRemaining() {
    return (data: TotalAvailableData): TotalAvailableMappedData => {
      return {
        max_interested_available_to_be_advanced: data.max_interested_available_to_be_advanced,
        date_to_be_paid: data.date_to_be_paid,
        days_remaining_to_be_paid: data.date_to_be_paid 
          ? getDateDiffInDays(new Date(), new Date(data.date_to_be_paid))
          : 0
      }
    }
  }
}
